module.exports = __webpack_public_path__ + "img/bmi-white.8423c8cb.svg";